import React, { useEffect, useState } from 'react'
import WorkorderService from "../../services/workorders";
import moment from 'moment';
export default function Workhours(props) {
  const [dates, setDates] = useState([]);
const   sortJSON = (data, key, way) =>{
  return data.sort(function(a, b) {
      var x = a[key];
      var y = b[key];
      if (way === '123') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      }
      if (way === '321') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      }
  });
}
  useEffect(() => {

    WorkorderService.getForUser(props.user._id)
      .then(result => {
        let tmpDates = [];
        let orderItems = [];
        //filter items in new list
        for (let i = 0; i < result.length; i++) {
          if (result[i].status === 3) {
            orderItems = orderItems.concat(result[i].items.filter((item) => { return item.active === true && item.user === props.user._id }));
          }
        }
        //collect dates
        for (let i = 0; i < orderItems.length; i++) {
          let dateKey = moment(orderItems[i].date).format('YYYY-MM');
         
          if (!tmpDates[dateKey]) { tmpDates[dateKey] = [] }
          tmpDates[dateKey].push(orderItems[i]);
        }


        setDates(tmpDates)
      }, err => { console.log(err) })

  }, [])

  let numOr0 = n => isNaN(n) ? 0 : n;
const printItems = (label,items)=>{
  let n = [];
  for(let i=0;i<items.length;i++){
   // console.log(label,items[i].date,items[i].minutes,items[i].minutesovertime,items[i].active,i);
    n.push(items[i]);//{id:items[i]._id,datum:items[i].date,uren:items[i].minutes,overuren:items[i].minutesovertime})
  }
   console.log(sortJSON(n,'datum','123'))
}
  const getHours = (items)=>{
    printItems('Uren',items);
    let totalMinutes = items.reduce((a, b) => a+numOr0(b.minutes), 0);
    console.log('Uren totaal ',Math.round(((totalMinutes / 60)) * 100, 2) / 100);
    return Math.round(((totalMinutes / 60)) * 100, 2) / 100;
  }
  const getHoursOvertime = (items)=>{
   /// printItems('Overuren',items);
    let totalMinutes = items.reduce((a, b) => a+numOr0(b.minutesovertime), 0);
    console.log('Overuren totaal',Math.round(((totalMinutes / 60)) * 100, 2) / 100);
    return Math.round(((totalMinutes / 60)) * 100, 2) / 100;

  }
  const getHoursRace = (items)=>{
    let totalMinutes = items.reduce((a, b) => a+numOr0(b.raceminutes), 0);
    return Math.round(((totalMinutes / 60)) * 100, 2) / 100;
  }

  const getHoursTravel = (items)=>{
    let total = items.reduce((a, b) => a+numOr0(b.travelhours), 0);
    return Math.round(((total)) * 100, 2) / 100;
  }

  const getNights = (items)=>{
    let total = items.reduce((a, b) => a+numOr0(b.nights), 0);
    return Math.round(((total)) * 100, 2) / 100;
  }

  const getKilometers = (items)=>{
    let total = items.reduce((a, b) => a+numOr0(b.kilometers), 0);
    return Math.round(((total )) * 100, 2) / 100;
  }
  return (
    <div className="padding">
      <table style={{width:'100%'}}><tbody>
        <tr><th>Maand</th><th>Uren</th><th>Overuren</th><th>Overnachtingen (aantal)</th><th>Reisuren</th><th>Kilometers</th><th>Gasgeven</th></tr>
        {Object.keys(dates).sort((a,b)=>{return a>b? -1: 1}).map(key => {
         return <tr key={key}><td>{key}</td><td style={{textAlign:'right'}}>{''+ getHours(dates[key])}</td><td style={{textAlign:'right'}}>{''+getHoursOvertime(dates[key])}</td><td style={{textAlign:'right'}}>{''+ getNights(dates[key])}</td><td style={{textAlign:'right'}}>{''+ getHoursTravel(dates[key])}</td><td style={{textAlign:'right'}}>{''+ getKilometers(dates[key])}</td><td style={{textAlign:'right'}}>{''+getHoursRace(dates[key])}</td></tr>
        })}
      </tbody></table>
    </div>
  )
}
